import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { LanguageProvider } from "@/contexts/LanguageContext";
import { AuthProvider } from "@/contexts/AuthContext";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import About from "@/pages/About";
import Rights from "@/pages/Rights";
import Bargaining from "@/pages/Bargaining";
import News from "@/pages/News";
import Events from "@/pages/Events";
import Executive from "@/pages/Executive";
import Community from "@/pages/Community";
import Resources from "@/pages/Resources";
import Contact from "@/pages/Contact";
import { Login, Register } from "@/pages/Auth";
import MemberPortal from "@/pages/MemberPortal";
import AdminDashboard from "@/pages/AdminDashboard";
import Gallery from "@/pages/Gallery";
import MemberCorner from "@/pages/MemberCorner";
import "@/App.css";

function App() {
  return (
    <LanguageProvider>
      <AuthProvider>
        <BrowserRouter>
          <Layout>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/about" element={<About />} />
              <Route path="/rights" element={<Rights />} />
              <Route path="/bargaining" element={<Bargaining />} />
              <Route path="/news" element={<News />} />
              <Route path="/events" element={<Events />} />
              <Route path="/executive" element={<Executive />} />
              <Route path="/gallery" element={<Gallery />} />
              <Route path="/member-corner" element={<MemberCorner />} />
              <Route path="/community" element={<Community />} />
              <Route path="/resources" element={<Resources />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/login" element={<Login />} />
              <Route path="/register" element={<Register />} />
              <Route path="/portal" element={<MemberPortal />} />
              <Route path="/admin" element={<AdminDashboard />} />
            </Routes>
          </Layout>
          <Toaster position="top-right" richColors />
        </BrowserRouter>
      </AuthProvider>
    </LanguageProvider>
  );
}

export default App;
